/* tslint:disable */
/* eslint-disable */
/**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { RecoverableFactorMethod } from './RecoverableFactorMethod';
import {
    RecoverableFactorMethodFromJSON,
    RecoverableFactorMethodFromJSONTyped,
    RecoverableFactorMethodToJSON,
} from './RecoverableFactorMethod';

/**
 * 
 * @export
 * @interface RecoverableFactor
 */
export interface RecoverableFactor {
    /**
     * 
     * @type {RecoverableFactorMethod}
     * @memberof RecoverableFactor
     */
    method: RecoverableFactorMethod;
}

/**
 * Check if a given object implements the RecoverableFactor interface.
 */
export function instanceOfRecoverableFactor(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "method" in value;

    return isInstance;
}

export function RecoverableFactorFromJSON(json: any): RecoverableFactor {
    return RecoverableFactorFromJSONTyped(json, false);
}

export function RecoverableFactorFromJSONTyped(json: any, ignoreDiscriminator: boolean): RecoverableFactor {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'method': RecoverableFactorMethodFromJSON(json['method']),
    };
}

export function RecoverableFactorToJSON(value?: RecoverableFactor | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'method': RecoverableFactorMethodToJSON(value.method),
    };
}

